module.exports = __webpack_public_path__ + "static/jmr-691e92b840f2f42a33bc6d3c141c447e.jpg";